"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = emitTypingActivityToPostActivitySaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _emitTypingIndicator = require("../actions/emitTypingIndicator");

var _postActivity = _interopRequireDefault(require("../actions/postActivity"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _marked = /*#__PURE__*/_regenerator["default"].mark(postTypingActivity),
    _marked2 = /*#__PURE__*/_regenerator["default"].mark(emitTypingActivityToPostActivity),
    _marked3 = /*#__PURE__*/_regenerator["default"].mark(emitTypingActivityToPostActivitySaga);

function postTypingActivity() {
  return _regenerator["default"].wrap(function postTypingActivity$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _postActivity["default"])({
            type: 'typing'
          }));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function emitTypingActivityToPostActivity() {
  return _regenerator["default"].wrap(function emitTypingActivityToPostActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(function (_ref) {
            var type = _ref.type;
            return type === _emitTypingIndicator.EMIT_TYPING_INDICATOR;
          }, postTypingActivity);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function emitTypingActivityToPostActivitySaga() {
  return _regenerator["default"].wrap(function emitTypingActivityToPostActivitySaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _whileConnected["default"])(emitTypingActivityToPostActivity);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJwb3N0VHlwaW5nQWN0aXZpdHkiLCJlbWl0VHlwaW5nQWN0aXZpdHlUb1Bvc3RBY3Rpdml0eSIsImVtaXRUeXBpbmdBY3Rpdml0eVRvUG9zdEFjdGl2aXR5U2FnYSIsInB1dCIsInBvc3RBY3Rpdml0eSIsInR5cGUiLCJ0YWtlRXZlcnkiLCJFTUlUX1RZUElOR19JTkRJQ0FUT1IiLCJ3aGlsZUNvbm5lY3RlZCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zYWdhcy9lbWl0VHlwaW5nSW5kaWNhdG9yVG9Qb3N0QWN0aXZpdHlTYWdhLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHB1dCwgdGFrZUV2ZXJ5IH0gZnJvbSAncmVkdXgtc2FnYS9lZmZlY3RzJztcblxuaW1wb3J0IHsgRU1JVF9UWVBJTkdfSU5ESUNBVE9SIH0gZnJvbSAnLi4vYWN0aW9ucy9lbWl0VHlwaW5nSW5kaWNhdG9yJztcbmltcG9ydCBwb3N0QWN0aXZpdHkgZnJvbSAnLi4vYWN0aW9ucy9wb3N0QWN0aXZpdHknO1xuaW1wb3J0IHdoaWxlQ29ubmVjdGVkIGZyb20gJy4vZWZmZWN0cy93aGlsZUNvbm5lY3RlZCc7XG5cbmZ1bmN0aW9uKiBwb3N0VHlwaW5nQWN0aXZpdHkoKSB7XG4gIHlpZWxkIHB1dChcbiAgICBwb3N0QWN0aXZpdHkoe1xuICAgICAgdHlwZTogJ3R5cGluZydcbiAgICB9KVxuICApO1xufVxuXG5mdW5jdGlvbiogZW1pdFR5cGluZ0FjdGl2aXR5VG9Qb3N0QWN0aXZpdHkoKSB7XG4gIHlpZWxkIHRha2VFdmVyeSgoeyB0eXBlIH0pID0+IHR5cGUgPT09IEVNSVRfVFlQSU5HX0lORElDQVRPUiwgcG9zdFR5cGluZ0FjdGl2aXR5KTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24qIGVtaXRUeXBpbmdBY3Rpdml0eVRvUG9zdEFjdGl2aXR5U2FnYSgpIHtcbiAgeWllbGQgd2hpbGVDb25uZWN0ZWQoZW1pdFR5cGluZ0FjdGl2aXR5VG9Qb3N0QWN0aXZpdHkpO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOztBQUVBOztBQUNBOztBQUNBOzt3REFFVUEsa0I7eURBUUFDLGdDO3lEQUllQyxvQzs7QUFaekIsU0FBVUYsa0JBQVY7RUFBQTtJQUFBO01BQUE7UUFBQTtVQUFBO1VBQ0UsT0FBTSxJQUFBRyxZQUFBLEVBQ0osSUFBQUMsd0JBQUEsRUFBYTtZQUNYQyxJQUFJLEVBQUU7VUFESyxDQUFiLENBREksQ0FBTjs7UUFERjtRQUFBO1VBQUE7TUFBQTtJQUFBO0VBQUE7QUFBQTs7QUFRQSxTQUFVSixnQ0FBVjtFQUFBO0lBQUE7TUFBQTtRQUFBO1VBQUE7VUFDRSxPQUFNLElBQUFLLGtCQUFBLEVBQVU7WUFBQSxJQUFHRCxJQUFILFFBQUdBLElBQUg7WUFBQSxPQUFjQSxJQUFJLEtBQUtFLDBDQUF2QjtVQUFBLENBQVYsRUFBd0RQLGtCQUF4RCxDQUFOOztRQURGO1FBQUE7VUFBQTtNQUFBO0lBQUE7RUFBQTtBQUFBOztBQUllLFNBQVVFLG9DQUFWO0VBQUE7SUFBQTtNQUFBO1FBQUE7VUFBQTtVQUNiLE9BQU0sSUFBQU0sMEJBQUEsRUFBZVAsZ0NBQWYsQ0FBTjs7UUFEYTtRQUFBO1VBQUE7TUFBQTtJQUFBO0VBQUE7QUFBQSJ9